import React, { useState } from 'react'
import { Modal } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import moment from 'moment'
import useCallApi from '../../../../hooks/useCallApi'
import NotesLog from '../../../../components/NotesLog/NotesLog'
import Affiliate from '../../../../templates/Affiliate/Affiliate'
import Loading from '../../../../templates/UI/Loading/Loading'

const HighMediumUnderJr = () => {
    const { dataLoaded, data } = useCallApi(`compliance/affiliates/highMediumJunior`, 'GET', {}, [])
    const [sortAsc, setSortAsc] = useState(false)
    const [showModal, setShowModal] = useState(false)
    const [selectedAffiliate, setSelectedAffiliate] = useState(null)

    const affiliates = [...(data?.affiliates || [])].sort((a, b) => {
        const aDate = a.priority_change_date ? moment(a.priority_change_date).valueOf() : 0
        const bDate = b.priority_change_date ? moment(b.priority_change_date).valueOf() : 0
        return sortAsc ? aDate - bDate : bDate - aDate
    })

    const openNotes = (affiliate) => {
        setSelectedAffiliate(affiliate)
        setShowModal(true)
    }

    const closeModal = () => {
        setShowModal(false)
        setSelectedAffiliate(null)
    }

    return (
        <>
            <Modal show={showModal} onHide={closeModal}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {selectedAffiliate ? `${selectedAffiliate.name} (${selectedAffiliate.id})` : 'Notes'}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedAffiliate && <NotesLog uri="compliance/affiliates/hmPromotion" id={selectedAffiliate.id} />}
                </Modal.Body>
            </Modal>
            <div className="card mb-3">
                <div className="card-header">
                    <div>High/Medium Under Jr. AM</div>
                </div>
                <div className="card-body p-0" style={{ fontSize: '0.9rem' }}>
                    <table className="table table-striped table-hover m-0">
                        <thead className="text-secondary">
                            <tr>
                                <th>ID</th>
                                <th>Affiliate</th>
                                <th style={{ cursor: 'pointer' }} onClick={() => setSortAsc(!sortAsc)}>
                                    Priority Change {sortAsc ? '▲' : '▼'}
                                </th>
                                <th>Note</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {dataLoaded ? (
                                affiliates.length === 0 ? (
                                    <tr>
                                        <td>No stats available</td>
                                    </tr>
                                ) : (
                                    affiliates.map((item) => {
                                        return (
                                            <tr key={item.affiliate.id}>
                                                <td>{item.affiliate.id}</td>
                                                <td>
                                                    <Affiliate aid={item.affiliate.id} name={item.affiliate.name} status={item.affiliate.status} priority={item.affiliate.priority} />
                                                </td>
                                                <td>{item.priority_change_date ? moment(item.priority_change_date).utc().format('YYYY-MM-DD') : '-'}</td>
                                                <td>{item.followup_note}</td>
                                                <td>
                                                    <button type="button" className="btn btn-link px-1" onClick={() => openNotes(item.affiliate)} title="Notes">
                                                        <FontAwesomeIcon icon="sticky-note" />
                                                    </button>
                                                </td>
                                            </tr>
                                        )
                                    })
                                )
                            ) : (
                                <tr>
                                    <td colSpan={5}>
                                        <Loading />
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    )
}

export default HighMediumUnderJr
